import { AxiosResponse } from 'axios';
import Store from '@/store/index';
import User from '@/models/User';
import moment from 'moment';
import Role from '@/models/Role';

export default class UserService {
    public async Login(userName: string, password: string) {
        const axios = require('axios').default;

        const postData = {
            Username: userName,
            Password: password
        };

        try {
            const endpoint = Store.state.basePath + Store.state.endpoints.login;
            const response: AxiosResponse = await axios.post(endpoint, postData);

            const userInfo: User = new User();

            userInfo.Id = response.data.Id;
            userInfo.CustomerId = response.data.CustomerId;
            userInfo.FirstName = response.data.FirstName;
            userInfo.LastName = response.data.LastName;
            userInfo.UserName = response.data.UserName;
            userInfo.IsAdmin = response.data.IsAdmin;
            userInfo.Token = response.data.Token;

            const d = moment().add(2, 'hours').toDate();
            document.cookie = `info=${JSON.stringify(response.data)}; expires=${d.toUTCString()}; path=/;`;
            Store.commit('setUserInfo', response.data);

            return { Error: false, Data: userInfo };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async Logout() {
        Store.commit('setUserInfo', '');
        document.cookie = 'info=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }

    public async LoadUser(id: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.userLoad;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?id=${id}`);

            let returnValue: User = new User();
            returnValue.Id = response.data.Id;
            returnValue.CustomerId = response.data.CustomerId;
            returnValue.FirstName = response.data.FirstName;
            returnValue.LastName = response.data.LastName;
            returnValue.Email = response.data.Email;
            returnValue.UserName = response.data.UserName;
            returnValue.Password = response.data.Password;
            returnValue.IsAdmin = response.data.IsAdmin;
            returnValue.Active = response.data.Active;
            returnValue.DateCreated = response.data.DateCreated;
            returnValue.DateUpdated = response.data.DateUpdated;

            return { Error: false, Data: returnValue };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async LoadCustomerUsers(roleId: number, customerId: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleGetUsers;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?roleId=${roleId}&customerId=${customerId}`);

            return { Error: false, Data: response.data };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async LoadScreenRoles(screenId: number, customerId: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.screenGetRoles;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?screenId=${screenId}&customerId=${customerId}`);

            return { Error: false, Data: response.data };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async AddUser(userInfo: User) {
        const postData = {
            CustomerId: userInfo.CustomerId,
            FirstName: userInfo.FirstName,
            LastName: userInfo.LastName,
            Email: userInfo.Email,
            UserName: userInfo.UserName,
            Password: userInfo.Password,
            IsAdmin: userInfo.IsAdmin,
            Active: userInfo.Active
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.userAdd;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: response.data.id };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async UpdateUser(userInfo: User) {
        const postData = {
            Id: userInfo.Id,
            FirstName: userInfo.FirstName,
            LastName: userInfo.LastName,
            Email: userInfo.Email,
            UserName: userInfo.UserName,
            Password: userInfo.Password,
            IsAdmin: userInfo.IsAdmin,
            Active: userInfo.Active
        };
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.userUpdate;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async DeleteUser(id: number) {
        const postData = {
            Id: id
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.userDelete;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.delete(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async LoadRole(id: number) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleLoad;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.get(`${methodEndpoint}?id=${id}`);

            let returnValue: Role = new Role();
            returnValue.Id = response.data.Id;
            returnValue.CustomerId = response.data.CustomerId;
            returnValue.Name = response.data.Name;
            returnValue.DateCreated = response.data.DateCreated;
            returnValue.DateUpdated = response.data.DateUpdated;

            return { Error: false, Data: returnValue };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async AddRole(roleInfo: Role) {
        const postData = {
            CustomerId: roleInfo.CustomerId,
            Name: roleInfo.Name
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleAdd;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: response.data.id };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async UpdateRole(roleInfo: Role) {
        const postData = {
            Id: roleInfo.Id,
            Name: roleInfo.Name
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleUpdate;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.put(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async DeleteRole(id: number) {
        const postData = {
            Id: id
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleDelete;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.delete(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async SaveRoleUsers(roleUsers: any) {
        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleSaveUsers;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, roleUsers);
            return { Error: false, Data: response.data.id };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async AddRoleToScreen(roleId: number, screenId: number) {
        const postData = {
            roleId: roleId,
            screenId: screenId
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleAddToScreen;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }

    public async RemoveRoleFromScreen(roleId: number, screenId: number) {
        const postData = {
            roleId: roleId,
            screenId: screenId
        };

        const methodEndpoint = Store.state.basePath + Store.state.endpoints.roleRemoveFromScreen;

        try {
            const axios = require('axios').default;
            const response: AxiosResponse = await axios.post(methodEndpoint, postData);
            return { Error: false, Data: null };
        } catch (error) {
            return { Error: true, Message: error };
        }
    }
}
